import { Vector } from '../../models';

export function newVector(x: number, y: number): Vector {
  return { x, y };
}
